// Players by the names people know them by (Ben, 2026-10-17): "Lionel Messi", not "Lionel
// Cuccittini" — the first + last words of the legal name go wrong for Spanish double surnames
// (Messi, Hincapié), Brazilians (Vinícius Júnior) and one-name players (Rodri). On ?live=1 the
// database's `nickname` (its "known as" name) wins, with our own corrections over the top for
// the few it gets wrong. The demo keeps first + last, as Ben's prototype did.
//
// Keyed by the full legal name: the name functions get a player record, which carries the name
// but not always an id. A nickname is learnt whenever the site sees one (a search, a pick, a
// Bio); the nightly Stats files don't carry it yet, so a list of players the site hasn't met
// still shows first + last.

import { LIVE } from "../live/flag.js";
import { NAME_CORRECTIONS } from "./name-corrections.js";

const known = new Map<string, string>();

/** Learn a player's familiar name. A nickname that's empty or just the legal name is skipped. */
export function rememberFamiliarName(fullName: string | null | undefined, nickname: string | null | undefined): void {
  const full = (fullName ?? "").trim();
  const nick = (nickname ?? "").trim();
  if (!LIVE || !full || !nick || nick === full) return;
  known.set(full, nick);
}

/** The name to show for a full legal name, when we know a better one (live only). */
export function familiarNameOf(fullName: string): string | undefined {
  if (!LIVE) return undefined;
  const full = fullName.trim();
  return NAME_CORRECTIONS[full] ?? known.get(full);
}
